import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'chileanCurrency'
})

export class ChileanCurrencyPipe implements PipeTransform {

  constructor(private currencyPipe: CurrencyPipe) { }

  transform(value: number, sign: string = 'symbol'): string | null {
    if (value !== null && value !== undefined && !isNaN(value)) {
      let output = this.currencyPipe.transform(value, 'USD', sign, '1.0-0');
      output = output?.replace(/,/g, '.') || null;
      return output;
    }
    return '$';
  }
}
